export default "__VITE_ASSET__df9cb217__"